import { render, staticRenderFns } from "./invoicecharge.vue?vue&type=template&id=6530594a&"
import script from "./invoicecharge.vue?vue&type=script&lang=js&"
export * from "./invoicecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports